import React from 'react';

import { useGetIssueTypeFields } from '../../services/useGetIssueTypeFields.tsx';
import { useSetOptionsColumns } from '../../utils/useSetOptionsColumns.tsx';
import { useInitMappings } from '../../utils/useInitMappings.tsx';
import { useMapTableToIssues } from '../../utils/useMapTableToIssues.tsx';
import { useHandleCloseAndAddIssuesToPage } from '../../services/useCloseAndAddIssuesToPage.tsx';
import { BulkConfigureView } from '../bulk-work-create-configure/BulkConfigureView.tsx';
import { BulkCreateDefaultView } from '../bulk-work-create-list/BulkCreateDefaultView.tsx';
import { useMapActionItemsToIssues } from '../../utils/useMapActionItemsToIssues.tsx';
import { useGetAllWorkflowValidators } from '../../services/useGetAllWorkflowValidators.tsx';

import { BulkEditIssueView } from './BulkEditIssueView.tsx';
import { BulkCreateFlagsContainer } from './BulkCreateFlagsContainer.tsx';

export const BulkNavigationContainer = ({ onClose }: { onClose: () => void }) => {
	useGetIssueTypeFields();
	useSetOptionsColumns();
	useInitMappings();
	useGetAllWorkflowValidators();
	useMapTableToIssues();
	useMapActionItemsToIssues();
	useHandleCloseAndAddIssuesToPage(onClose);

	return (
		<>
			<BulkCreateDefaultView onClose={onClose} />
			<BulkConfigureView closePanel={onClose} />
			<BulkEditIssueView />
			<BulkCreateFlagsContainer />
		</>
	);
};
